import { registerSW } from 'virtual:pwa-register';

export const PWA_STATUS_EVENT = 'cosmo:pwa-status';

export interface PwaStatus {
  readonly offlineReady: boolean;
  readonly updateReady: boolean;
  readonly atSafeBoundary: boolean;
}

class PwaUpdateManager {
  private registered = false;
  private offlineReady = false;
  private updateReady = false;
  private atSafeBoundary = false;
  private applyUpdate?: (reloadPage?: boolean) => Promise<void>;

  register() {
    if (this.registered) return;
    this.registered = true;
    this.applyUpdate = registerSW({
      immediate: true,
      onOfflineReady: () => {
        this.offlineReady = true;
        this.publish();
      },
      onNeedRefresh: () => {
        this.updateReady = true;
        this.publish();
      },
      onRegisterError: error => {
        console.error('[PWA] Service worker registration failed.', error);
      },
    });
  }

  setSafeBoundary(safe: boolean) {
    this.atSafeBoundary = safe;
    this.publish();
  }

  getStatus(): PwaStatus {
    return {
      offlineReady: this.offlineReady,
      updateReady: this.updateReady,
      atSafeBoundary: this.atSafeBoundary,
    };
  }

  /**
   * The host UI may call this only at a safe boundary after confirmation.
   * Without confirmation, the waiting worker activates on a clean relaunch.
   */
  async activateWaitingUpdate() {
    if (!this.updateReady || !this.atSafeBoundary || !this.applyUpdate) return false;
    await this.applyUpdate(true);
    return true;
  }

  private publish() {
    window.dispatchEvent(new CustomEvent<PwaStatus>(PWA_STATUS_EVENT, {
      detail: this.getStatus(),
    }));
  }
}

export const pwaUpdates = new PwaUpdateManager();
